<p-dialog
  [(visible)]="visible"
  [header]="headerTemplate ? undefined : header"
  [modal]="modal"
  [blockScroll]="blockScroll"
  [closable]="closable"
  [showHeader]="showHeader"
  [draggable]="draggable"
  [resizable]="resizable"
  [appendTo]="appendTo"
  [style]="{ width: width }"
  (onHide)="handleVisibleChange(false)"
  [styleClass]="styleClass"
  [maskStyleClass]="maskStyleClass"
>
  <!-- Custom Header Template -->
  <ng-template pTemplate="header" *ngIf="headerTemplate">
    <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
  </ng-template>

  <!-- Modal Content -->
  <ng-container *ngIf="contentTemplate; else defaultContent">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ng-container>

  <ng-template #defaultContent>
    <ng-content></ng-content>
  </ng-template>

  <!-- Modal Footer -->
  <ng-template pTemplate="footer" *ngIf="showFooter">
    <ng-container *ngIf="footerTemplate; else defaultFooter">
      <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    </ng-container>

    <ng-template #defaultFooter>
      <div class="modal-footer">
        <button
          *ngIf="showCancelButton"
          pButton
          type="button"
          [label]="cancelLabel"
          class="p-button-text p-button-secondary"
          (click)="handleCancel()"
        ></button>
        <button
          *ngIf="showConfirmButton"
          pButton
          type="button"
          [label]="confirmLabel"
          class="p-button-primary"
          [disabled]="confirmButtonDisabled"
          (click)="handleConfirm()"
        ></button>
      </div>
    </ng-template>
  </ng-template>
</p-dialog>


